mutation validateSignUpToken($input: ValidateSignUpTokenInput!) {
  validateSignUpToken(input: $input)
}
